import { useTheme } from '@mui/material/styles';
import { Typography } from '@mui/material';
import { useStyles } from './style';

/**
 * @name NavTitle
 * @description Displays title navigation links
 * @param {*} param0 - Destructured object
 * @param {string} param0.title - Footer navigation titles
 * @returns {JSX.Element} ReactElement
 */
const NavTitle = ({ title }) => {
  const theme = useTheme();
  const style = useStyles(theme);
  return (
    <Typography variant='h6' component='p' role='heading' aria-level='2' sx={style.navTitle}>
      {title}
    </Typography>
  );
};

NavTitle.displayName = 'NavTitle';
export default NavTitle;
